<template>
  <!-- :bodyStyle="{ padding: '20px' }" -->
  <a-card title="评价管理" :bordered="false"
          :headStyle="{ borderBottom: '0px', fontSize: '18px', paddingLeft: '20px' }"
  >
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="商品ID" v-bind="searchItemLayout">
            <a-input v-model="queryParams.proId" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="商品名称" v-bind="searchItemLayout">
            <a-input v-model="queryParams.proName" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="整体评价" v-bind="searchItemLayout">
            <a-select
              style="width: 100%"
              v-model="queryParams.evaluationType"
              placeholder="请选择" allowClear
            >
              <a-select-option value="1">一般</a-select-option>
              <a-select-option value="2">不满意</a-select-option>
              <a-select-option value="3">满意</a-select-option>
            </a-select>
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item label="评价日期" v-bind="searchItemLayout">
            <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
          </a-form-item>
          <a-form-item style="margin-left:5%;">
            <a-button type="primary" @click="searchBtn">查询</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <custom-page-table
      ref="table"
      rowKey="evaluationId"
      :columns="columns"
      :requestPromise="loadPromise"
      :queryParams="queryParams"
    >
      <div slot="contentSlots" slot-scope="data">
        <a-tooltip placement="topLeft">
          <template slot="title">{{ data.record.evaluationComments }}</template>
          <div class="pro_title">{{ data.record.evaluationComments }}</div>
        </a-tooltip>
      </div>
      <div slot="proSlots" slot-scope="data">
        <div><a class="a-url" :href="data.record.proH5Url" target="_blank">{{ data.text }}</a></div>
        <div>商品ID：{{ data.record.evaluationProId }}</div>
        <div v-if="data.record.evaluationOptionName">
          <span v-if="data.record.evaluationProCatalogId==1">票型：{{ data.record.evaluationOptionName }}</span>
          <span v-else-if="data.record.evaluationProCatalogId==2">房型：{{ data.record.evaluationOptionName }}</span>
          <span v-else>套餐：{{ data.record.evaluationOptionName }}</span>
        </div>
      </div>
      <div slot="action" slot-scope="data">
        <a v-if="data.record.replyStatus == 0" @click="replyEvaluate(data.record,1)">回复</a>
        <a v-else @click="replyEvaluate(data.record,2)">查看回复</a>
      </div>
    </custom-page-table>
    <a-modal title="回复评价"
             :visible="evaluatVisible"
             @ok="affirmEvaluation"
             :confirmLoading="confirmLoading"
             @cancel="handleCancel"
             okText="修改回复" cancelText="取消"
    >
      <detail-list :col="1">
        <detail-list-item term="评价人">{{ evaluateData.evaluationMemberName }}</detail-list-item>
        <detail-list-item term="评价内容">{{ evaluateData.evaluationComments }}</detail-list-item>
      </detail-list>
      <a-textarea v-model="evaluationReply" placeholder="请填写回复内容~140个字以内" :maxLength="140" :rows="4"/>
    </a-modal>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'Evaluate',
  mixins: [searchForm],
  data() {
    return {
      queryParams: {},
      evaluatVisible: false,
      confirmLoading: false,
      selectedDate: undefined,
      evaluateData: '',
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: 'ID',
          dataIndex: 'evaluationId'
        },
        {
          title: '评价内容',
          dataIndex: 'evaluationComments',
          scopedSlots: { customRender: 'contentSlots' },
          width: '30%'
        },
        {
          title: '整体评价',
          dataIndex: 'evaluation'
        },
        {
          title: '评价时间',
          dataIndex: 'evaluationDate'
        },
        {
          title: '评价人',
          dataIndex: 'evaluationMemberName'
        },
        {
          title: '所属商品',
          dataIndex: 'evaluationProName',
          scopedSlots: { customRender: 'proSlots' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      pageNo: 1,
      pageSize: 10,
      evaluationReply: '',
      type: 1,
      strText: '回复'
    }
  },
  mounted() {
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getProService().post('evaluation/getEvaluationCommentList', params)
    },
    handleCancel() {
      this.evaluatVisible = false
    },
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    //日期变更
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.evaluationStartTime = dateStrArr[0]//出游开始日期
      this.queryParams.evaluationEndTime = dateStrArr[1]//出游结束日期
    },
    // 回复
    affirmEvaluation() {
      this.confirmLoading = true
      this.strText = this.type == 1 ? '回复' : '修改回复'
      this.getHttpServices().getProService().post('evaluation/evaluationReply', {
        evaluationId: this.evaluationId,
        evaluationReply: this.evaluationReply
      }).then(res => {
        this.getLogUtils().logWithTag('==affirmEvaluation==', res)
        this.$message.success(this.strText + '成功')
        this.evaluatVisible = false
        this.$refs.table.refresh()
        this.confirmLoading = false
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.confirmLoading = false)
    },
    // 赋值
    replyEvaluate(data, status) {
      this.type = status
      this.evaluatVisible = true
      this.evaluateData = data
      this.evaluationId = data.evaluationId
      this.evaluationReply = data.evaluationReply
    }
  }
}
</script>
<style scoped lang="less">
.a-url {
  color: rgba(0, 0, 0, 0.65);
}

.pro_title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>